/**
 * Assist wording: what a typed command sounds like on the radio, for the aircraft card's "say"
 * line. Pure; the card renders it.
 */
import { callsignPhrase, parseCommand, phraseInstruction, type Sim } from '@atc/sim';

/** The transmission a typed command stands for: the spoken callsign once, then each instruction. Null when it is not an aircraft command for an aircraft in the sim. */
export function phraseFor(sim: Pick<Sim, 'find' | 'airport'>, command: string): string | null {
  const transfer = /^(\S+)\s+CTW$/i.exec(command.trim());
  if (transfer) {
    const ac = sim.find(transfer[1]!.toUpperCase());
    return ac ? `${callsignPhrase(ac, sim.airport.xAtc.telephony).speech}, contact tower` : null;
  }
  const parsed = parseCommand(command);
  if (!parsed.ok || parsed.command.type !== 'aircraft' || !parsed.command.instructions.length) return null;
  const ac = sim.find(parsed.command.callsign);
  if (!ac) return null;
  const tel = sim.airport.xAtc.telephony;
  // atc.text is "CALLSIGN, body"; keep the body only.
  const bodies = parsed.command.instructions.map((i) => phraseInstruction(ac, i, sim.airport, tel).atc.text.slice(ac.callsign.length + 2));
  return `${callsignPhrase(ac, tel).speech}, ${bodies.join(', ')}`;
}
